import {domify} from 'min-dom';
import {createVueApp} from "@/src/vueUtil";
import X2JS from "x2js";
import _ from "lodash-es";

export function elementToString(e) {
  if (!e) {
    return '<null>';
  }

  return '<' + e.$type + (e.id ? ' id="' + e.id : '') + '" />';
}

export function ucFirst(s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
}

export function createVueDom(component, containerId, element, provideObj={}) {
    const dom = domify(`<div id="${containerId}">`);
    setTimeout(() => {
        const app = createVueApp(component);
        //https://vuejs.org/guide/components/provide-inject.html#working-with-reactivity, unwrapInjectedRef is necessary to make the provided element reactive
        app.config.unwrapInjectedRef = true;
        //provide method allow the use of 'inject' property inside the component
        app.provide('element', element)
        Object.keys(provideObj).forEach(key => {
            app.provide(key, provideObj[key])
        });
        app.mount(`#${containerId}`)
    },100)
    return dom;
}

/**
 * list of keys inside the json that should be arrays, so that they need a plural key
 */
const remapFields = {
    nestingActivity: 'nestingActivities',
    activity: 'activities',
    exclude: 'excludes',
    include: 'includes',
    condition: 'conditions',
    response: 'responses',
    milestone: 'milestones',
    preCondition: 'preConditions',
    noResponse: 'noResponses',
}

/**
 * check key inside the element, substitute it with remapKey and transform the content to array if not already
 * @param element
 * @param key
 * @param remapKey
 */
function replacer(element, key, remapKey) {
    if (!element[key]) {
        return
    }
    let innerElement = element[key];
    element[remapKey] = _.isArray(innerElement) ? innerElement : [innerElement];
    delete element[key];
    if (key === 'activity' || remapKey === 'activity') {
        //check for nested activities
        element[remapKey].forEach(activity => replacer(activity, key, remapKey))
    }
    if (key === 'nestingActivity' || remapKey === 'nestingActivity') {
        const subKey = key.replace('nesting', '').toLowerCase()
        const subRemapKey = remapKey.replace('nesting', '').toLowerCase();
        element[remapKey].forEach(activity => {
            //check for nesting activities
            if (activity[subKey]) {
                replacer(activity, subKey, subRemapKey);
            }
        });
    }
}

// recursively find in data the key "nestedExpression" and convert it to an array if it is not already
// the same nestedExpression can have children, so we need to check recursively
function fixNestedExpressionRecursively(data) {
    if (Array.isArray(data)) {
        data.forEach(item => fixNestedExpressionRecursively(item));
    } else if (typeof data === 'object' && data !== null) {
        Object.keys(data).forEach(key => {
            if (key === 'expressions') {
                if (!Array.isArray(data[key])) {
                    data[key] = [data[key]];
                }
            }
            fixNestedExpressionRecursively(data[key]);
        });
    }
}

/**
 * converts xml to json and replace fields in remap fields
 * @param xmlData
 * @returns Object jsonData
 */
export function xmlToJson(xmlData) {
    const x2js = new X2JS();
    let jsonData = x2js.xml2js(xmlData);
    if (!jsonData) {
        return null;
    }
    jsonData = JSON.parse(JSON.stringify(jsonData).replaceAll(/\u00a0/g, ' '))
    Object.keys(remapFields).forEach(key => replacer(jsonData.definitions.odBoard, key, remapFields[key]));
    //fix nestedExpression to be an array
    fixNestedExpressionRecursively(jsonData.definitions.odBoard);
    return jsonData
}

/**
 * converts json to xml and replace back the fields
 * @param jsonString
 * @returns xml string
 */
export function jsonToXml(jsonString) {
    const x2js = new X2JS();
    let jsonData = typeof jsonString === 'string' ? JSON.parse(jsonString) : jsonString;
    //inverted remapKey and key
    Object.keys(remapFields).forEach(key => replacer(jsonData.definitions.odBoard, remapFields[key], key));
    return x2js.js2xml(jsonData);
}
